<div class="skeleton-wrapper">
    <div class="flex flex-row w-full gap-3 justify-content-between">
        <div class="flex flex-column col-8 gap-5">
            <div *ngFor="let i of [].constructor(5)">
                <p-skeleton width="100%" height="1em"></p-skeleton>
            </div>
        </div>
        <div class="flex flex-column col-3">
            <p-skeleton width="100%" height="13em"></p-skeleton>
        </div>
    </div>
    <div class="flex flex-column col-8 gap-5 mt-3 w-full">
        <div *ngFor="let i of [].constructor(5)">
            <p-skeleton width="100%" height="1em"></p-skeleton>
        </div>
    </div>
</div>